import clsx from 'clsx';

export function InlineArrowRightIcon({ className, ...rest }) {
  return (
    <svg
      className={clsx(className)}
      width="0.78em"
      height="0.68em"
      viewBox="15.5 0.65 11.85 10.45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...rest}
    >
      <path
        d="M22.1472 10.9091L21.2722 10.0454L24.8745 6.44317H15.5449V5.19317H24.8745L21.2722 1.60226L22.1472 0.727262L27.2381 5.81817L22.1472 10.9091Z"
        fill="currentColor"
      />
    </svg>
  );
}
